import { Pipe, PipeTransform } from '@angular/core';
import { SavingPlanSuggestion } from '@zero/saving-plans/domain';

@Pipe({
  name: 'suggestionPercentage',
  standalone: true,
})
export class SuggestionPercentagePipe implements PipeTransform {
  public transform({ amount }: SavingPlanSuggestion, suggestions: SavingPlanSuggestion[]): string {
    const suggestionSum = suggestions.reduce<number>((previousValue, { amount }) => previousValue + amount, 0);
    return suggestionSum === 0 ? '0' : ((100 * amount) / suggestionSum).toFixed(0);
  }
}
